import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { fullScreenHandler } from "../Helper";
import { getIcon } from "../../../helpers/icons";

import Link from "../../../components/Link";
import Title from "../../../components/Title";
import Section from "../../../components/Section";
import Background from "../../../components/Background";
import Zoominblack from "../../../assets/image/icons/zoominblack.svg";
import Zoomoutblack from "../../../assets/image/icons/zoomoutblack.svg";
import Zoominwhite from "../../../assets/image/icons/zoominwhite.svg";
import Zoomoutwhite from "../../../assets/image/icons/zoomoutwhite.svg";

import style from "./style.module.css";

export default function DocumentViewer(props) {
    const {
        name = "",
        media_type = "",
        backButton = true,
        document_images = []
    } = props;
    const navigate = useNavigate();

    const [index, setIndex] = useState(0);
    const [fullScreen, setFullScreen] = useState(false);
    const [zoomLevel, setZoomLevel] = useState(1);

    useEffect(() => {
        ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "msfullscreenchange"].forEach(
            eventType => document.addEventListener(eventType, fullscreenchanged, false)
        );
        return (() => {
            ["fullscreenchange", "webkitfullscreenchange", "mozfullscreenchange", "msfullscreenchange"].forEach(
                eventType => document.removeEventListener(eventType, fullscreenchanged, false)
            );
        })
    }, []);

    const fullscreenchanged = () => {
        setTimeout(() => {
            if (document.fullscreenElement) {
                setFullScreen(document.fullscreenElement ? true : false);
            }
            else if (document.webkitCurrentFullScreenElement) {
                setFullScreen(document.webkitCurrentFullScreenElement ? true : false);
            } else {
                setFullScreen(false);
            }
        }, 500);
    }

    useEffect(() => {
        let ele = document.getElementsByClassName(style.documentViewer);
        if (ele.length > 0) {
            fullScreenHandler(fullScreen, ele[0]);
        }
    }, [fullScreen]);

    const toggleSlide = (newIndex) => {
        if (newIndex < 1) {
            setIndex(0);
        }
        else if (newIndex >= (document_images.length - 1)) {
            setIndex(document_images.length - 1);
        }
        else {
            setIndex(newIndex);
        }
    }

    const handleZoom = (direction) => {
        setZoomLevel((prev) => {
            if (direction === "out") {
                return prev <= 1 ? 1 : Math.max(prev - 0.2, 0.5);
            }
            if (direction === "in") {
                return Math.min(prev + 0.2, 2);
            }
            return prev;
        });
    };
    console.log(props);

    return (
        <Section id="documentViewer" className={`${style.documentViewer} ${media_type !== "" ? style[media_type] : ""} ${fullScreen ? ` ${style.fullScreen}` : ''}`}>
            {
                backButton === true && (
                    <div className={style.backButtonWrap}>
                        <Link
                            onClick={() => { navigate(-1) }}
                            className={`${style.backButton}`}
                        >
                            <i className={getIcon("Arrow-left")}></i>
                        </Link>
                    </div>
                )
            }
            {
                document_images.length > 0 && (
                    <div className={style.documentViewerWrap}>
                        <div className={style.sizer}></div>
                        <div className={`${style.documentViewerList}`} style={{
                            transform: `scale(${zoomLevel})`,
                            transformOrigin: "top center",
                            transition: "transform 0.3s ease-in-out",
                        }}>
                            {
                                document_images.map((src, pIndex) => (
                                    <div key={`documentItem_${pIndex}`} className={`${style.documentItem} ${style.media}${index === pIndex ? ` ${style.show}` : ""}`}>
                                        <Background src={src} size="1440x0" />
                                    </div>
                                ))
                            }
                        </div>
                        <div className={style.zoomControls}>
                            <Link
                                onClick={() => handleZoom("out")}
                                className={style.zoomOut}
                            >
                                <div>
                                    <img src={Zoomoutblack} alt="Zoom out" />
                                </div>
                                <div>
                                    <img src={Zoomoutwhite} alt="Zoom out" />
                                </div>
                            </Link>
                            <Link
                                onClick={() => handleZoom("in")}
                                className={style.zoomIn}
                            >
                                <div>
                                    <img src={Zoominblack} alt="Zoom in" />
                                </div>
                                <div>
                                    <img src={Zoominwhite} alt="Zoom in" />
                                </div>
                            </Link>
                        </div>
                        {
                            media_type === "presentation" && (
                                <div className={style.controls}>
                                    <div className={style.controlsWrap}>
                                        <div className={style.colRow}>
                                            <Link
                                                onClick={() => toggleSlide(index - 1)}
                                                className={`${index < 1 ? style.disable : ""} ${style.prev}`}
                                            >
                                                <i className={getIcon("Prevstep")}></i>
                                            </Link>
                                            <div className={style.info}>
                                                {
                                                    name && (
                                                        <Title tag="p">{name}</Title>
                                                    )
                                                }
                                                <Title tag="p">{`Slide ${index + 1}`}</Title>
                                            </div>
                                            <Link
                                                onClick={() => toggleSlide(index + 1)}
                                                className={`${index === document_images.length - 1 ? style.disable : ""} ${style.next}`}
                                            >
                                                <i className={getIcon("Nextstep")}></i>
                                            </Link>
                                            <Link
                                                onClick={() => handleZoom("out")}
                                                className={style.zoomOut}
                                            >
                                                <div>
                                                    <img src={Zoomoutblack} alt="Zoom out" />
                                                </div>
                                                <div>
                                                    <img src={Zoomoutwhite} alt="Zoom out" />
                                                </div>
                                            </Link>
                                            <Link
                                                onClick={() => handleZoom("in")}
                                                className={style.zoomIn}
                                            >
                                                <div>
                                                    <img src={Zoominblack} alt="Zoom in" />
                                                </div>
                                                <div>
                                                    <img src={Zoominwhite} alt="Zoom in" />
                                                </div>
                                            </Link>
                                        </div>
                                        <Link onClick={() => setFullScreen(!fullScreen)}>
                                            <i className={getIcon(fullScreen ? "Exitfullscreen" : "Fullscreen")}></i>
                                        </Link>
                                    </div>
                                </div>
                            )
                        }
                    </div>
                )
            }
        </Section>
    )
}